import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import Img from "gatsby-image";
import {
  Typography,
  Container,
  Grid,
  Paper,
  Button,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import HeroVideo from "../assets/videos/hero.mp4";
import HeroVideoWebM from "../assets/videos/hero.webm";
const heroHeight = "700px";
const HeroImage = () => {
  const data = useStaticQuery(graphql`
    query {
      hero: file(relativePath: { eq: "hero/hero2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1980, maxHeight: 650, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
            presentationWidth
          }
        }
      }
    }
  `);
  let normalizedProps = data.hero.childImageSharp;
  if (normalizedProps.fluid && normalizedProps.fluid.presentationWidth) {
    normalizedProps = {
      ...normalizedProps,
      style: {
        ...(normalizedProps.style || {}),
        maxWidth: normalizedProps.fluid.presentationWidth,
        margin: "0 auto", // Used to center the image
        height: heroHeight,
      },
    };
  }
  return <Img {...normalizedProps} />;
};

const HomeHero = (props) => {
  const theme = useTheme();
  const xsDown = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <div>
      <video
        style={{
          width: "100%",
          height: heroHeight,
          objectFit: "cover",
        }}
        loop={true}
        autoPlay
        id="vid"
        muted
        poster="http://app.takeshapeadventures.com.au/wp-content/uploads/2020/10/morocco-boats1.jpg"
      >
        <source src={HeroVideo} type="video/mp4" />
        <source src={HeroVideoWebM} type="video/webm" />
      </video>
      <Grid
        container
        style={{
          position: "absolute",
          top: 55,
          height: heroHeight,
          backgroundColor: "rgba(30,0,0,0.3)",
        }}
      >
        <Container>
          <Grid container style={{ height: heroHeight }} alignContent="center">
            <Grid item xs={12} align="center" style={{ marginBottom: 15 }}>
              <Typography variant={"h1"} style={{ color: "white" }}>
                Creating memories that <br></br> last a lifetime
              </Typography>
            </Grid>
            <Grid
              item
              container
              xs={12}
              alignContent="center"
              justify="center"
              style={{ marginBottom: 15 }}
            >
              <Grid item container xs={12} align="center" justify="center">
                <Link color="inherit" to={"/calendar"}>
                  <Button
                    variant="outlined"
                    style={{
                      color: "white",
                      borderColor: "white",
                      borderWidth: "2px",
                      borderRadius: "60px",
                      marginRight: !xsDown ? 15 : 0,
                      marginTop: xsDown ? 15 : 0,
                    }}
                  >
                    View Calendar
                  </Button>
                </Link>
                <Link color="inherit" to={"/membership"}>
                  <Button
                    variant="outlined"
                    style={{
                      color: "white",
                      borderColor: "white",
                      borderWidth: "2px",
                      borderRadius: "60px",
                      marginLeft: !xsDown ? 15 : 0,
                      marginTop: xsDown ? 15 : 0,
                    }}
                  >
                    Become a member
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </div>
  );
};
export default HomeHero;
